import { useFilters } from "../../Common/Hooks/useFilters"

export interface DateFilterLinkProps {
	dateTimeString: string
}

export function DateFilterLink(props: DateFilterLinkProps): JSX.Element {

	const { addFilter } = useFilters()

	return (
		// eslint-disable-next-line jsx-a11y/anchor-is-valid
		<a className='filter' href='#' onClick={(e) => {
			e.preventDefault()
			addFilter('dateRange', `${props.dateTimeString}`)
		}}>
			{props.dateTimeString}
		</a>
	)
}
